import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@mui/styles';
import PropTypes from 'prop-types';
import { addDays } from 'date-fns';
import { LocationsUtil, withIsMobile } from 'utils';
import { withRouter } from 'utils';
import {
  DocumentDialogWithLink,
} from './DocumentDialogWithLink';
import axios from 'axios';
import axiosInstance from 'utils/axiosUtil';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Typography,
  Chip,
  FormControl,
  FormControlLabel,
  Checkbox,
  InputLabel,
  Select,
  MenuItem,
  Icon,
  ListItemText,
  Box,
  Tooltip,
} from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';

import {
  DateUtil,
  EncounterTypeUtil,
  StoreUtil,
} from 'doctivity-shared/utils/';
import {
  FindProviderDialog,
  SmallIconTextButton,
  LoadingView,
  ConfirmationDialog,
  ProviderCommentDeleteDialog,
} from '.';
import { FindContactDialog } from 'contacts';
import { FindLocationDialog } from 'locations';
import { MileageDialog } from 'mileage';
import { StarkDialog } from 'stark';
import { STARK_CATEGORY_MAP } from 'stark';

import { showConfirmationDialog } from 'store/actions/systemActions';
import {
  API_TAG_NAMESPACES_LIST_BY_CLIENT,
  listTagNamespacesByClient,
} from 'store/actions/tagNamespacesActions';

import {
  getProviderComment,
  deleteProviderComment,
} from 'store/actions/providerCommentsActions';

import {
  listActiveUsers,
} from 'store/actions/usersActions';
import { invalidateStark } from 'store/actions/starkActions';
import { invalidateMileage } from 'store/actions/mileageActions';
import { TagsUtil } from '../utils';

const styles = (theme) => ({
  smartSuggestionsContainer: {
    flexBasis: '30%',
    marginLeft: theme.spacing(2),
    borderLeft: '1px solid #999999',
    marginTop: -parseInt(theme.spacing(2)),
    marginBottom: -parseInt(theme.spacing(2)),
  },
  smartSuggestions: {
    padding: theme.spacing(2),
  },
  dateField: {
    paddingBottom: theme.spacing(1),
  },
  selectField: {
    minWidth: '200px',
  },
  providers: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(3),
  },
  providersLabel: {
    fontSize: 12,
    color: 'rgba(0, 0, 0, 0.6)',
    paddingBottom: theme.spacing(1),
  },
  textField: {
    width: '100%',
  },

  typeContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(1),
    flexWrap: 'wrap',

    justifyContent: 'space-right',
    '& > *': {
      marginBottom: theme.spacing(1),
    },
  },
  typeSpacer: {
    width: theme.spacing(2),
  },
  spaceLeft: {
    marginLeft: theme.spacing(1),
  },
  followUpContainer: {
    display: 'flex',
    paddingTop: theme.spacing(1),
  },
  twoColumnContainer: {
    display: 'flex',
    paddingTop: theme.spacing(1),
  },
  icon: {
    height: 17,
    fontSize: 17,
    color: '#666666',
    marginRight: 6,
  },
  locationContainer: {
    paddingBottom: theme.spacing(3),
  },
  modalContent: {
    padding: theme.spacing(1),
  },
  tagSelector: {
    flexBasis: '*',
    minWidth: '200px'
  },
  fullTagSelector: {
    flexBasis: '100%',
  },
  leftIcon: {
    marginRight: theme.spacing(1),
  },
  attachIcon: {
    transform: 'rotate(45deg)',
    marginRight: 4,
  },
  buttonIcon: {
    marginRight: 4,
  },
  actionButtons: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'flex-start',
    gap: theme.spacing(0.5),
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  attachmentsRow: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(0.5),
    alignItems: 'center',
    paddingBottom: theme.spacing(1),
  },
});

const DEFAULT_DUE_DAYS = 7;

// Encounter types where mileage is not applicable (no in-person travel).
// Matches EncounterTypeUtil IDs: Email=1, Call=2, Text=3, Virtual Meeting=6,
// Social Media=8, Direct Mail=9.
const NON_MILEAGE_ENCOUNTER_IDS = new Set([1, 2, 3, 6, 8, 9]);

class ProviderCommentsDialog extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isNew: true,
      comment: '',
      commentDate: new Date(),
      providers: [],
      contacts: [],
      documents: [],
      locations: [],
      findProviderOpen: false,
      findContactOpen: false,
      findLocationOpen: false,
      confirmCloseOpen: false,
      mileageDialogOpen: false,
      editingMileageLog: null,
      linkedMileageLogs: [],
      starkDialogOpen:   false,
      editingStarkLog:   null,
      linkedStarkLogs:   [],
      encounterTypeId: 0,
      tagSelect: {},
      needsFollowUp: false,
      dueDate: addDays(new Date(), DEFAULT_DUE_DAYS),
      dataModified: false,
      showDeletePrompt: false,
      // Assigned user: admins must pick one; non-admins default to themselves
      assignedUserId: props.user?.is_admin ? null : (props.user?.id || null),
    };
    if (props.tag) {
      this.state.tagSelect[props.tag.namespace.id] = [props.tag.id];
    }
  }

  componentDidMount() {
    const { data } = this.props;
    this.resetData(data);

    // Load client users for the user assignment dropdown (all roles need this now)
    this.props.dispatch(listActiveUsers(this.props.clientId));

    if (
      StoreUtil.needsLoadLongCache(this.props.tagNamespaces) ||
      this.props.tagNamespaces.clientId !== this.props.clientId
    ) {
      // this.fetchTagNamespaces();
    }
    if (data && data.id) {
      this.fetchCommentFromDataId();
      if (this.props.duplicate) {
        this.setState({isNew: true});
      } else {
        this.setState({isNew: false});
      }
    }
    if (this.props.tag) {
      const current = this.state.tagSelect[this.props.tag.namespace.id] ?? [];
      this.setState({
        tagSelect: {
          ...this.state.tagSelect,
          [this.props.tag.namespace.id]: Array.from(
            new Set([...(current ?? []), this.props.tag.id]),
          ),
        },
      });
    }
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.provider !== prevProps.provider ||
      this.props.contact !== prevProps.contact ||
      this.props.location !== prevProps.location ||
      this.props.document !== prevProps.document
    ) {
      // Pass data so that resetData re-fetches linked Stark / Mileage chips
      // even when the provider/contact/location/document context changes.
      this.resetData(this.props.data);
    } else if (this.props.data && this.props.data !== prevProps.data) {
      // Only do a full reset when switching to a different note.
      // If it's the same note refreshed from the API (fetchCommentFromDataId),
      // skip the reset — it would clear linkedStarkLogs mid-flight and cause
      // chips to vanish while the second fetch is in-flight.
      const noteChanged = !prevProps.data || this.props.data.id !== prevProps.data.id;
      if (noteChanged) {
        this.resetData(this.props.data);
      }
    }

    if (
      StoreUtil.needsLoadLongCache(this.props.tagNamespaces) ||
      this.props.tagNamespaces.clientId !== this.props.clientId
    ) {
      this.fetchTagNamespaces();
    }

    if (prevProps.created.data !== this.props.created.data) {
      this.onContactSelected(this.props.created.data);
    }
  }

  resetData(data) {

    //if (this.document) {
      //this.document.docid = this.state.docId;
    //}

    const newState = {
      providers: this.props.provider ? [this.props.provider] : [],
      contacts: this.props.contact ? [this.props.contact] : [],
      documents: this.props.document ? [this.props.document] : [],
      locations: this.props.location ? [this.props.location] : [],
      comment: '',
      commentDate: new Date(),
      encounterTypeId: 0,
      tagSelect: {},
      needsFollowUp: false,
      dueDate: addDays(new Date(), DEFAULT_DUE_DAYS),
      confirmCloseOpen: false,
      dataModified: false,
      linkedMileageLogs: [],
      linkedStarkLogs:   [],
      assignedUserId: this.props.user?.is_admin ? null : (this.props.user?.id || null),
    };
    if (data && data.id) {
      newState.comment = data.body;
      newState.commentDate = new Date(data.comment_date);
      if (data.providers && data.providers.length > 0) {
        newState.providers = data.providers;
      }
      if (data.contacts && data.contacts.length > 0) {
        newState.contacts = data.contacts;
      }
      if (data.locations && data.locations.length > 0) {
        newState.locations = data.locations;
      }
      if (data.documents && data.documents.length > 0) {
        newState.documents = data.documents;
      }
      if (data.uploads && data.uploads.length > 0) {
        newState.uploads = data.uploads;
      }
      newState.encounterTypeId = data.encounter_type_id || 0;
      if (data.tags) {
        data.tags.forEach((tag) => {
          if (!newState.tagSelect[tag.namespace_id]) {
            newState.tagSelect[tag.namespace_id] = [];
          }
          newState.tagSelect[tag.namespace_id].push(tag.id);
        });
      }
      newState.needsFollowUp = data.needs_followup;

      // Pre-populate the assigned user:
      // - Admin (create or edit): use the note's current user_id
      // - Non-admin copy: default to themselves (they can change it)
      // - Non-admin edit: pre-populate with current owner so they can see / change it
      if (this.props.duplicate && !this.props.user?.is_admin) {
        newState.assignedUserId = this.props.user?.id || null;
      } else if (data.user_id) {
        newState.assignedUserId = data.user_id;
      }

      if (data.due_date) {
        newState.dueDate = new Date(data.due_date);
      } else {
        newState.dueDate = addDays(new Date(), DEFAULT_DUE_DAYS);
      }

      if (this.props.tag) {
        const { tag } = this.props;
        const current = newState.tagSelect[tag.namespace.id];
        current.push(tag);
        newState.tagSelect[tag.namespace.id] = Array.from(new Set(current));
      }
    }
    this.setState(newState, () => {
      if (data && data.id) {
        this.fetchLinkedMileageLog(data.id);
        // Stark entries are not copied — a duplicate note starts with none.
        // The user can add new ones if needed.
        if (!this.props.duplicate) {
          this.fetchLinkedStarkLogs(data.id);
        }
      }
    });
  }

  fetchTagNamespaces() {
    this.props.dispatch(listTagNamespacesByClient(this.props.clientId));
  }

  fetchLinkedMileageLog(noteId) {
    if (!noteId) return;
    axiosInstance.get(`/v2/mileage/by-note/${noteId}`)
      .then((response) => {
        // Backend returns a single object (or null) — not an array.
        const log = response?.data;
        if (log && log.id) {
          this.setState({
            linkedMileageLogs: [{
              id:             log.id,
              date_of_trip:   log.date_of_trip,
              destination:    log.destination,
              is_business:    log.is_business,
              is_company_car: log.is_company_car ?? false,
              purpose:        log.purpose,
              mileage:        log.mileage != null ? String(log.mileage) : '',
              start_odometer: log.start_odometer,
              end_odometer:   log.end_odometer,
            }],
          });
        }
      })
      .catch((err) => {
        console.error('fetchLinkedMileageLog failed', err);
      });
  }

  fetchLinkedStarkLogs(noteId) {
    if (!noteId) return;
    axiosInstance.get(`/v2/stark/by-note/${noteId}`)
      .then((response) => {
        const logs = response?.data;
        if (Array.isArray(logs)) {
          this.setState({ linkedStarkLogs: logs });
        }
      })
      .catch((err) => {
        console.error('fetchLinkedStarkLogs failed', err);
      });
  }

  /**
   * Returns true when any linked Stark entry has a provider that is no longer
   * on the note. The note cannot be saved until the user resolves the mismatch.
   */
  _starkReconcileRequired() {
    const { linkedStarkLogs, providers } = this.state;
    if (!linkedStarkLogs || linkedStarkLogs.length === 0) return false;
    const noteProviderIds = new Set((providers || []).map((p) => p.id));
    return linkedStarkLogs.some((log) =>
      (log.allocations || []).some((a) => !noteProviderIds.has(a.provider_id))
    );
  }

  fetchCommentFromDataId() {
    const { dispatch, data } = this.props;
    dispatch(getProviderComment(data.id));
  }

  getRequiredNamespaces() {
    const namespaces = TagsUtil.getNamespacesByType(
      'activity_notes',
      this.props.tagNamespaces,
    );
    return namespaces.filter((ns) => ns.activity_notes_required);
  }

  isSaveDisabled() {
    const { comment, commentDate  } = this.state;

    const requiredNamespaces = this.getRequiredNamespaces();
    if (requiredNamespaces?.length > 0 && this.state.tagSelect) {
      for (const ns of requiredNamespaces) {
        if (
          !this.state.tagSelect[ns.id] ||
          this.state.tagSelect[ns.id].length === 0
        ) {
          return true;
        }
      }
    }

    // Block save when Stark entries reference providers no longer on the note
    if (this._starkReconcileRequired()) return true;

    // A user must always be selected in every mode — no note can be saved without one.
    if (!this.state.assignedUserId) {
      return true;
    }

    return (
      !comment ||
      comment.length === 0 ||
      !commentDate
       //||  (providers.length < 1 && contacts.length < 1 && !location)
    );
  }

  render() {
    const { classes, open, provider, contact, document, clientId, isMobile , app} = this.props;

    const namespacesWithTagsSorted =
      TagsUtil.getNamespacesByType(
        'activity_notes',
        this.props.tagNamespaces,
      ) || [];

    const {
      isNew,
      comment,
      commentDate,
      providers,
      contacts,
      documents,
      locations,
      findProviderOpen,
      findContactOpen,
      findLocationOpen,
      confirmCloseOpen,
      encounterTypeId,
      showDeletePrompt,
      assignedUserId,
    } = this.state;

    const isAdminCreate = this.props.user.is_admin && isNew;
    const isAdminEdit   = this.props.user.is_admin && !isNew;
    const isUserCreate  = !this.props.user.is_admin && isNew && !this.props.duplicate;
    const isUserCopy    = !this.props.user.is_admin && !!this.props.duplicate;
    const isUserEdit    = !this.props.user.is_admin && !isNew;

    // Assignable users differ by context:
    // - Admin: everyone non-admin except themselves
    // - Non-admin create or copy: all non-admin users (including themselves)
    // - Non-admin edit: other non-admin users only (passing to someone else)
    const assignableUsers = this.props.user.is_admin
      ? (this.props.clientUsers || []).filter((u) => !u.is_admin && u.id !== this.props.user.id)
      : (isUserCreate || isUserCopy)
        ? (this.props.clientUsers || []).filter((u) => !u.is_admin)
        : (this.props.clientUsers || []).filter((u) => !u.is_admin && u.id !== this.props.user.id);

    const saveDisabled = this.isSaveDisabled();

    // Disable "Log Mileage" for encounter types that involve no in-person travel,
    // unless mileage has already been logged (allow editing existing records).
    const { linkedMileageLogs, linkedStarkLogs } = this.state;
    const mileageDisabled =
      NON_MILEAGE_ENCOUNTER_IDS.has(encounterTypeId) &&
      linkedMileageLogs.length === 0;

    return (
      <>
        <Dialog
          onClose={this.onCancel}
          aria-labelledby='simple-dialog-title'
          open={open}
          fullScreen={this.props.isMobile}
          fullWidth
          maxWidth='lw'
          scroll='paper'
        >
          <DialogTitle>Activity Note</DialogTitle>
          <DialogContent dividers>
            <div className={classes.modalContent}>
              <Box
                className={classes.twoColumnContainer}
                sx={{ flexDirection: ['column', 'row'] }}
              >
                <div className={classes.typeContainer}>
                <FormControl >
                  {this.props.isMobile ? (
                    <DateTimePicker
                      className={classes.dateField}
                      label='Date'
                      value={commentDate}
                      onChange={this.onDateChange}
                      renderInput={(params) => <TextField {...params} />}
                      format={DateUtil.LDML_DISPLAY_DATE_TIME_INPUT_FORMAT}
                      maxDate={new Date()}
                    />
                  ) : (
                    <DatePicker
                      className={classes.dateField}
                      label='Date'
                      value={commentDate}
                      onChange={this.onDateChange}
                      renderInput={(params) => <TextField {...params} />}
                      format={DateUtil.LDML_DISPLAY_DATE_TIME_INPUT_FORMAT}
                      maxDate={new Date()}
                    />
                  )}
                </FormControl>

                <FormControl>
                  <InputLabel id='type-label'>Encounter Type</InputLabel>
                  <Select
                    className={classes.selectField}
                    labelId='type-label'
                    id='type-select'
                    value={encounterTypeId || ''}
                    label='Encounter Type'
                    onChange={this.onEncounterTypeChange}
                  >
                    {EncounterTypeUtil.getAll().map((t) => (
                      <MenuItem value={t.id} key={t.id}>
                        <Icon className={classes.icon}>{t.icon}</Icon>
                        {t.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                </div>
              </Box>

              {/* User selector — shown in all modes */}
              {(isAdminCreate || isAdminEdit || isUserCreate || isUserCopy || isUserEdit) && (
                <Box sx={{ paddingTop: 1, paddingBottom: 1, display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 2 }}>
                  <FormControl variant='outlined' sx={{ width: 240 }}>
                    <InputLabel shrink id='assign-user-label'>
                      {isAdminCreate ? 'User *' : 'User'}
                    </InputLabel>
                    <Select
                      notched
                      labelId='assign-user-label'
                      id='assign-user-select'
                      label={isAdminCreate ? 'User *' : 'User'}
                      value={assignedUserId || ''}
                      onChange={this.onAssignedUserChange}
                      displayEmpty
                      renderValue={(selected) => {
                        if (!selected) return <em>(Select a user)</em>;
                        // Search all client users so the name always shows correctly,
                        // even when the selected user isn't in the filtered dropdown list.
                        const u = (this.props.clientUsers || []).find((u) => u.id === selected);
                        return u ? `${u.first_name} ${u.last_name}` : <em>(Select a user)</em>;
                      }}
                    >
                      <MenuItem value=''>
                        <em>(Select a user)</em>
                      </MenuItem>
                      {assignableUsers.map((u) => (
                        <MenuItem value={u.id} key={u.id}>
                          {u.first_name} {u.last_name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  {!isNew && (linkedStarkLogs.length > 0 || linkedMileageLogs.length > 0) && (
                    <Typography variant='caption' color='text.secondary' sx={{ maxWidth: 320 }}>
                      Changing the user also reassigns this note&apos;s mileage and non-monetary
                      compensation (Stark) entries to that user.
                    </Typography>
                  )}
                </Box>
              )}

              <div className={classes.providers}>
                <Typography className={classes.providersLabel}>
                  Providers &amp; Contacts:
                </Typography>
                {providers.map((p) => (
                  <Chip
                    label={`${p.last_name}, ${p.first_name}`}
                    onDelete={
                      provider && p.id === provider.id
                        ? undefined
                        : () => {
                            this.onDeleteProvider(p);
                          }
                    }
                    variant='outlined'
                    key={p.id}
                  />
                ))}
                {contacts.map((c) => (
                  <Chip
                    label={`${c.last_name}, ${c.first_name}`}
                    onDelete={
                      contact && c.id === contact.id
                        ? undefined
                        : () => {
                            this.onDeleteContact(c);
                          }
                    }
                    variant='outlined'
                    key={c.id}
                  />
                ))}
                
                <SmallIconTextButton
                  icon='add'
                  text='Provider'
                  onClick={this.onAddProvider}
                />
                <SmallIconTextButton
                  icon='add'
                  text='Contact'
                  onClick={this.onAddContact}
                />
              </div>
              <div className={classes.locationContainer}>
                <Typography className={classes.providersLabel}>
                  Locations:
                </Typography>
                {locations.map((l) => (
                   <Chip
                    label={LocationsUtil.formatNameOrAddress(l)}
                    onDelete={() => {
                      this.onDeleteLocation(l);
                    }}
                    variant='outlined'
                    key={l.id}
                  />                  
                ))}
                
              
                <SmallIconTextButton
                  icon='add'
                  text='Location'
                  onClick={this.onAddLocation}
                />

              </div>
              <div className={classes.typeContainer}>
                {!StoreUtil.isLoaded(this.props.tagNamespaces) ? (
                  <LoadingView />
                ) : (
                  namespacesWithTagsSorted.map((namespace) => (
                    <FormControl
                      variant='outlined'
                      className={
                        !isMobile && namespacesWithTagsSorted.length > 1
                          ? classes.tagSelector
                          : classes.fullTagSelector
                      }
                      key={namespace.id}
                    >
                      <InputLabel shrink={true} id={`label-${namespace.id}`}>
                        {`${namespace.name} ${namespace.activity_notes_required ? '*' : ''}`}
                      </InputLabel>
                      <Select
                        notched={true}
                        labelId={`label-${namespace.id}`}
                        id={`select-${namespace.id}`}
                        displayEmpty={true}
                        value={
                          namespace.activity_notes_multiple
                            ? this.state.tagSelect[namespace.id] || []
                            : (this.state.tagSelect[namespace.id] &&
                                this.state.tagSelect[namespace.id].length > 0 &&
                                this.state.tagSelect[namespace.id][0]) ||
                              ''
                        }
                        label={`${namespace.name} ${namespace.activity_notes_required ? '*' : ''}`}
                        onChange={(event) => {
                          this.onTagSelectChange(event, namespace);
                        }}
                        multiple={namespace.activity_notes_multiple || false}
                        variant='outlined'
                        renderValue={(selected) => {
                          if (
                            namespace.activity_notes_multiple &&
                            selected?.length > 0
                          ) {
                            return selected
                              .map(
                                (id) =>
                                  namespace.tags.find((t) => t.id === id).name,
                              )
                              .join(', ');
                          }
                          const tag = namespace.tags.find(
                            (t) => t.id === selected,
                          );
                          if (tag) {
                            return tag.name;
                          }
                          return <em>(None)</em>;
                        }}
                      >
                        {!namespace.activity_notes_multiple &&
                          !namespace.activity_notes_required && (
                            <MenuItem value={0} key={0}>
                              <em>(None)</em>
                            </MenuItem>
                          )}
                        {namespace.activity_notes_multiple
                          ? namespace.tags.map((tag) => (
                              <MenuItem value={tag.id} key={tag.id}>
                                <Checkbox
                                  checked={
                                    this.state.tagSelect[namespace.id] !==
                                      undefined &&
                                    this.state.tagSelect[namespace.id].includes(
                                      tag.id,
                                    )
                                  }
                                />
                                <ListItemText primary={tag.name} />
                              </MenuItem>
                            ))
                          : namespace.tags.map((tag) => (
                              <MenuItem value={tag.id} key={tag.id}>
                                {tag.name}
                              </MenuItem>
                            ))}
                      </Select>
                    </FormControl>
                  ))
                )}
              </div>
              <TextField
                label='Record your Activity Notes*'
                multiline
                rows={4}
                variant='outlined'
                value={comment}
                onChange={this.onTextChange}
                className={classes.textField}
              />

              <div className={classes.followUpContainer}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={!!this.state.needsFollowUp}
                      onChange={this.onFollowUpChange}
                    />
                  }
                  label='Needs Resolution'
                />

                {this.state.needsFollowUp && (
                  <DatePicker
                    className={classes.dateField}
                    label='Due Date'
                    value={this.state.dueDate }
                    onChange={this.onDueDateChange}
                    renderInput={(params) => <TextField {...params} />}
                    format={DateUtil.LDML_DISPLAY_FORMAT}
                    minDate={new Date()}
                    fullWidth
                  />
                )}
              </div>
            </div>
            <div className={classes.attachmentsRow}>
            {documents.map((d) => {
              if (!d.docId && d.name) {
                d.docId = d.ProviderCommentDocuments.document_id;
                d.file = {name: d.name};
              }
            })}
            {documents.map((d) => (
                  <Chip
                    label={`${d.file.name}`}
                    onDelete={
                      document && d.file.name === document.file.name
                        ? undefined
                        : () => {
                            this.onDeleteDocument(d);
                          }
                    }
                    variant='outlined'
                    key={d.id}
                  />
                ))}
            {this.state.linkedMileageLogs.map((m, i) => (
              <Chip
                key={`mileage-${i}`}
                label={`Mileage: ${m.mileage} mi on ${m.date_of_trip}`}
                variant='outlined'
                style={{ cursor: 'pointer' }}
                onClick={() => this.setState({ mileageDialogOpen: true, editingMileageLog: m })}
                onDelete={() => this.onDeleteMileageLog(m)}
              />
            ))}
            {this.state.linkedStarkLogs.map((log, i) => {
              const catLabel = STARK_CATEGORY_MAP[log.category] || 'Stark';
              // spending_date is a DATEONLY string (e.g. '2026-05-15'). Passing it
              // directly to new Date() parses as UTC midnight and toLocaleDateString()
              // would show the previous day for all US users. Slice and display as-is.
              const dateStr  = log.spending_date
                ? log.spending_date.slice(0, 10)
                : '';
              return (
                <Chip
                  key={`stark-${log.id || i}`}
                  label={`${catLabel}: $${parseFloat(log.total_amount || 0).toFixed(2)} on ${dateStr}`}
                  variant='outlined'
                  style={{ cursor: 'pointer' }}
                  onClick={() => this.setState({ starkDialogOpen: true, editingStarkLog: log })}
                  onDelete={() => this.onDeleteStarkLog(log)}
                />
              );
            })}
            {this._starkReconcileRequired() && (
              <Box mt={1} mb={1}>
                <Typography
                  variant="body2"
                  color="error"
                  style={{ fontSize: 12 }}
                >
                  ⚠ Provider list changed — please update or remove your Stark entries before saving.
                </Typography>
              </Box>
            )}
            </div>
            <div className={classes.actionButtons}>
              <Tooltip
                title={mileageDisabled ? 'Mileage is not applicable for this encounter type' : ''}
                placement='top'
              >
                <span>
                  <Button
                    color='secondary'
                    size='small'
                    disabled={mileageDisabled}
                    onClick={() => this.setState({
                      mileageDialogOpen: true,
                      editingMileageLog: this.state.linkedMileageLogs[0] || null,
                    })}
                  >
                    <Icon className={classes.buttonIcon}>directions_car</Icon>
                    Log Mileage
                  </Button>
                </span>
              </Tooltip>
              <Button
                color='secondary'
                size='small'
                onClick={() => this.setState({ starkDialogOpen: true, editingStarkLog: null })}
              >
                <Icon className={classes.buttonIcon}>attach_money</Icon>
                Add Stark Entry
              </Button>
              <Button
                color='secondary'
                size='small'
                onClick={() => this.openUploadDialog(undefined)}
              >
                <Icon className={classes.attachIcon}>attach_file</Icon>
                Attach Document
              </Button>
            </div>


          </DialogContent>
          <DialogActions>

            { !isNew && (this.props.user.is_admin || this.props.user.id === this.props.data.user_id) && (
              <Button onClick={this.onDelete} color='primary'>
                <Icon>delete</Icon>
              </Button>
            )}
            <Button onClick={this.onCancel} color='primary'>
              Cancel
            </Button>
            <Button
              onClick={this.onSave}
              color='primary'
              variant='contained'
              disabled={saveDisabled}
            >
              Save
            </Button>
          </DialogActions>
        </Dialog>

        <DocumentDialogWithLink
            clientId={app.selectedClient}
            isDataUpload={false}
            open={this.state.isUploadDialogOpen}
            onClose={this.closeUploadDialog}
            onExited={this.handleUploadExited}
            onLink={this.linkDocument}           
            onUpload={this.startUpload}
            uploadState={this.state.uploadDialogState}
            uploadProgress={this.state.uploadProgress}
            editing={this.state.editingDocument || null}
          />

        {this.state.mileageDialogOpen && (
          <MileageDialog
            open={this.state.mileageDialogOpen}
            onClose={() => this.setState({ mileageDialogOpen: false, editingMileageLog: null })}
            clientId={this.props.clientId}
            activityNoteId={this.props.data?.id || null}
            inActivityNote
            log={this.state.editingMileageLog}
            defaultUserId={!this.state.editingMileageLog ? this.state.assignedUserId : undefined}
            isAdmin={this.props.user?.is_admin}
            clientUsers={this.props.clientUsers}
            defaultTripDestination={
              !this.state.editingMileageLog && this.state.locations?.length > 0
                ? LocationsUtil.formatFullNameAndAddress(this.state.locations[0])
                : undefined
            }
            onSaved={(summary) => {
              this.setState({
                linkedMileageLogs: [summary],
                mileageDialogOpen: false,
                editingMileageLog: null,
              });
            }}
            onDelete={(log) => {
              axiosInstance.delete(`/v2/mileage/logs/${log.id}`)
                .then(() => {
                  this.setState({
                    linkedMileageLogs: [],
                    mileageDialogOpen: false,
                    editingMileageLog: null,
                  });
                })
                .catch((err) => {
                  console.error('MileageDialog delete failed', err);
                });
            }}
          />
        )}

        {this.state.starkDialogOpen && (
          <StarkDialog
            open={this.state.starkDialogOpen}
            onClose={() => this.setState({ starkDialogOpen: false, editingStarkLog: null })}
            clientId={this.props.clientId}
            fromActivityNote
            activityNoteId={this.props.data?.id || null}
            log={this.state.editingStarkLog}
            providers={this.state.providers || []}
            initialDescription={this.state.editingStarkLog ? undefined : this.state.comment}
            onSaved={(savedLog) => {
              // Refresh the linked stark logs list from the server
              const noteId = this.props.data?.id;
              this.setState({ starkDialogOpen: false, editingStarkLog: null }, () => {
                if (noteId) {
                  this.fetchLinkedStarkLogs(noteId);
                } else {
                  // New note — savedLog.id is a pending id; track it for afterCRUDUpsert
                  this.setState((prev) => ({
                    linkedStarkLogs: [
                      ...prev.linkedStarkLogs.filter((l) => l.id !== savedLog.id),
                      savedLog,
                    ],
                  }));
                }
              });
            }}
            onDeleted={(deletedId) => {
              this.setState((prev) => ({
                starkDialogOpen: false,
                editingStarkLog: null,
                linkedStarkLogs: prev.linkedStarkLogs.filter((l) => l.id !== deletedId),
              }));
            }}
          />
        )}

        {findProviderOpen && (
          <FindProviderDialog
            clientId={clientId}
            provider={provider}
            selectedProviderIds={providers ? providers.map((p) => p.id) : null}
            selectedContactId={contacts ? contacts.map((c) => c.id): null}
            selectedLocationId={locations ? locations.map((l) => l.id): null}
            selectedLabelId={
              Object.values(this.state.tagSelect).flatMap((m) => m)
                //namespacesWithTagsSorted ? namespacesWithTagsSorted?.flatMap((ns) =>
                  //  ns.tags.map((t) => t.id),
                  //)
                //: []
            }
            open={findProviderOpen}
            onMultiSelect={this.onProvidersMultiSelected}
          />
        )}
        {findContactOpen && (
          <FindContactDialog
            clientId={clientId}
            contact={contact}
            selectedContactIds={contacts ? contacts.map((c) => c.id) : null}
            selectedProviderId={providers ? providers.map((p) => p.id) : null}
            selectedLocationId={locations ? locations.map((l) => l.id): null}
            open={findContactOpen}
            onMultiSelect={this.onContactsMultiSelected}
          />
        )}
        {findLocationOpen && (
          <FindLocationDialog
            open={findLocationOpen}
            showSuggested
            selectedContactId={contacts ? contacts.map((c) => c.id) : null}
            selectedProviderId={providers ? providers.map((p) => p.id) : null}
            selectedLocationId={locations ? locations.map((l) => l.id) : null}
            //onSelect={this.onLocationSelected}
            onMultiSelect={this.onLocationsMultiSelected}
            //onClose={() => this.onLocationSelected(null)}
          />
        )}
        {showDeletePrompt && (
          <ProviderCommentDeleteDialog
            data={this.props.data}
            onClose={this.cancelDelete}
            open={showDeletePrompt}
            onDelete={this.deleteComment}
          />
        )}
        <ConfirmationDialog
          open={confirmCloseOpen}
          title='Close Dialog?'
          content='You will lose any unsaved changes.'
          onClose={this.onCloseConfirmCancel}
          onCancel={this.onCloseConfirmCancel}
          onConfirm={this.onConfirmCancel}
        />
      </>
    );
  }

  openUploadDialog = (editingDocument) => {
    this.setState({
      isUploadDialogOpen: true,
      uploadDialogState: 'EDIT',
      editingDocument,
    });
  };

  handleUploadExited = () => {
    this.setState({
      uploadDialogState: 'EDIT',
    });
  };

  closeUploadDialog = () => {
    if (this.state.uploadDialogState !== 'LOADING') {
      this.setState({
        isUploadDialogOpen: false,
        editingDocument: null,
      });
    }
  };


  onAddProvider = () => {
    this.setState({
      findProviderOpen: true,
    });
  };

  onProviderSelected = (provider) => {
    if (!provider) {
      // cancel sends a null provider, just close
      this.setState({
        findProviderOpen: false,
      });
    } else {
      this.setState((state) => {
        let existing = false;
        state.providers.forEach((p) => {
          if (p.id === provider.id) {
            existing = true;
          }
        });
        if (!existing) {
          state.providers.push(provider);
        }
        return {
          providers: state.providers,
          findProviderOpen: false,
          dataModified: true,
        };
      });
    }
  };

  onProvidersMultiSelected = (providers) => {
    if (!providers) {
      // cancel sends a null provider, just close
      this.setState({
        findProviderOpen: false,
      });
    } else {
      this.setState((state) => {
        providers.forEach((newProvider) => {
          let existing = false;
          state.providers.forEach((p) => {
            if (p.id === newProvider.id) {
              existing = true;
            }
          });
          if (!existing) {
            state.providers.push(newProvider);
          }
        });

        return {
          providers: state.providers,
          findProviderOpen: false,
          dataModified: true,
        };
      });
    }
  };

  onContactsMultiSelected = (contacts) => {
    if (!contacts) {
      // cancel sends a null provider, just close
      this.setState({
        findContactOpen: false,
      });
    } else {
      this.setState((state) => {
        contacts.forEach((newContact) => {
          let existing = false;
          state.contacts.forEach((p) => {
            if (p.id === newContact.id) {
              existing = true;
            }
          });
          if (!existing) {
            state.contacts.push(newContact);
          }
        });

        return {
          contacts: state.contacts,
          findContactOpen: false,
          dataModified: true,
        };
      });
    }
  };

  onLocationsMultiSelected = (locations) => {
    if (!locations) {
      // cancel sends a null locations, just close
      this.setState({
        findLocationOpen: false,
      });
    } else {
      this.setState((state) => {
        locations.forEach((newLocation) => {
          let existing = false;
          state.locations.forEach((l) => {
            if (l.id === newLocation.id) {
              existing = true;
            }
          });
          if (!existing) {
            state.locations.push(newLocation);
          }
        });

        return {
          locations: state.locations,
          findLocationOpen: false,
          dataModified: true,
        };
      });
    }
  };


  onDeleteProvider = (provider) => {
    if (!this.props.provider || provider.id !== this.props.provider.id) {
      this.setState((state) => {
        if (
          !this.props.data ||
          !this.props.data.id 
          || // not editing
          state.contacts.length + state.providers.length > 0
        ) {
          const i = state.providers.indexOf(provider);
          //if (i >= 0) {
            state.providers.splice(i, 1);
          //}
        }
        return { providers: state.providers, dataModified: true };
      });
    }
  };

  onDeleteDocument = (document) => {
    if (!this.props.document || document.file.name !== this.props.document.file.id) {
      this.setState((state) => {
        if (
          !this.props.data ||
          !this.props.data.id 
          || // not editing
          state.contacts.length + state.providers.length > 0
        ) {
          const i = state.documents.indexOf(document);
          //if (i >= 0) {
            state.documents.splice(i, 1);
          //}
        }
        return { documents: state.documents, dataModified: true };
      });
    }
  };

  onDeleteMileageLog = (log) => {
    if (log.id) {
      axiosInstance.delete(`/v2/mileage/logs/${log.id}`)
        .then(() => {
          this.setState({ linkedMileageLogs: [] });
        })
        .catch((err) => {
          console.error('MileageDialog delete failed', err);
        });
    } else {
      this.setState({ linkedMileageLogs: [] });
    }
  };

  onDeleteStarkLog = (log) => {
    if (log.id) {
      axiosInstance.delete(`/v2/stark/logs/${log.id}`)
        .then(() => {
          this.setState((state) => ({
            linkedStarkLogs: state.linkedStarkLogs.filter((l) => l.id !== log.id),
          }));
        })
        .catch((err) => {
          console.error('StarkLog delete failed', err);
        });
    } else {
      // Entry was never saved (pending) — remove from local list only
      this.setState((state) => ({
        linkedStarkLogs: state.linkedStarkLogs.filter((l) => l !== log),
      }));
    }
  };

  onAddContact = () => {
    this.setState({
      findContactOpen: true,
    });
  };

  onContactSelected = (contact) => {
    if (!contact) {
      // cancel sends a null contact, just close
      this.setState({
        findContactOpen: false,
      });
    } else {
      this.setState((state) => {
        let existing = false;
        state.contacts.forEach((c) => {
          if (c.id === contact.id) {
            existing = true;
          }
        });
        if (!existing) {
          state.contacts.push(contact);
        }
        return {
          contacts: state.contacts,
          findContactOpen: false,
          dataModified: true,
        };
      });
    }
  };

  onDeleteContact = (contact) => {
    if (!this.props.contact || contact.id !== this.props.contact.id) {
      this.setState((state) => {
        if (
          !this.props.data ||
          !this.props.data.id 
          || // not editing
          state.contacts.length + state.providers.length > 0
        ) {
          const i = state.contacts.indexOf(contact);
          //if (i >= 0) {
            state.contacts.splice(i, 1);
          //}
        }
        return { contacts: state.contacts, dataModified: true };
      });
    }
  };

  onAddLocation = () => {
    this.setState({
      findLocationOpen: true,
    });
  };

  onLocationSelected = (location) => {
    if (!location) {
      // cancel sends a null location, just close
      this.setState({
        findLocationOpen: false,
      });
    } else {
      this.setState((state) => {
        let existing = false;
        state.locations.forEach((l) => {
          if (l.id === location.id) {
            existing = true;
          }
        });
        if (!existing) {
          state.locations.push(location);
        }
        return {
          locations: state.locations,
          findLocationOpen: false,
          dataModified: true,
        };
      });
    }
  };

  onDeleteLocation = (location) => {
    if (!this.props.location || location.id !== this.props.location.id) {
      this.setState((state) => {
        if (
          !this.props.data ||
          !this.props.data.id 
          || // not editing
          state.locations.length > 0
        ) {
          const i = state.locations.indexOf(location);
          //if (i >= 0) {
            state.locations.splice(i, 1);
          //}
        }
        return { locations: state.locations, dataModified: true };
      });
    }
  };

  onDelete = () => {
    this.setState({ showDeletePrompt: true });
  };
  cancelDelete = () => {
    this.setState({ showDeletePrompt: false });
  };
  deleteComment = (data) => {
    this.props.dispatch(deleteProviderComment(data.id));
    this.props.router.navigate(-1);
  };

  onCancel = (event, reason) => {
    const { dataModified } = this.state;

    if (
      dataModified &&
      !this.isSaveDisabled() &&
      reason &&
      reason === 'backdropClick'
    ) {
      this.setState({ confirmCloseOpen: true });
      return;
    }

    this.onConfirmCancel();
  };

  onConfirmCancel = () => {
    const { onClose } = this.props;

    this.resetData();
    if (onClose) {
      onClose();
    }
  };

  onSave = () => {
    const {
      comment,
      commentDate,
      providers,
      contacts,
      documents,
      locations,
      encounterTypeId,
      needsFollowUp,
      dueDate,
      assignedUserId,
    } = this.state;

    // if coming from dashboard, set id
    const providerIds = providers.map((p) =>
      p.id ? p.id : p.provider_id
    );
    const contactIds = contacts.map((c) =>
      c.id ? c.id : c.contact_id
    );
    const documentIds = documents.map((d) => d.docId);
    const locationIds = locations.map((l) =>
      l.id ? l.id : l.location_id
    );
    if (this.isSaveDisabled() || (needsFollowUp && !dueDate)) {
      return;
    }

    const tags = [];
    const namespaces = Object.values(this.state.tagSelect);
    if (namespaces) {
      namespaces.forEach((namespace) => {
        tags.push(...namespace);
      });
    }

    const { linkedMileageLogs, linkedStarkLogs } = this.state;
    const pendingMileageIds = linkedMileageLogs.map((m) => m.id).filter(Boolean);
    const pendingStarkIds   = linkedStarkLogs.map((l) => l.id).filter(Boolean);

    const toSave = {
      body: comment,
      comment_date: commentDate,
      providers: providerIds,
      contacts: contactIds,
      documents: documentIds,
      locations: locationIds,
      encounter_type_id: encounterTypeId || null,
      tags,
      needs_followup: needsFollowUp,
      due_date: (needsFollowUp && dueDate) || null,
      ...(pendingMileageIds.length ? { pending_mileage_ids: pendingMileageIds } : {}),
      ...(pendingStarkIds.length   ? { pending_stark_ids:  pendingStarkIds }   : {}),
    };
    if (this.props.data && this.props.data.id) {
      toSave.id = this.props.data.id;
    }

    if (this.props.duplicate) {
      toSave.id = null;
    }

    toSave.user_id = assignedUserId;

    this.props.onSave(toSave);

    // Signal any mounted tracking pages to re-fetch so new data appears immediately.
    if (pendingStarkIds.length > 0) {
      this.props.dispatch(invalidateStark());
    }
    if (pendingMileageIds.length > 0) {
      this.props.dispatch(invalidateMileage());
    }
  };

  onTextChange = (event) => {
    this.setState({
      comment: event.target.value,
      dataModified: true,
    });
  };

  onDateChange = (newDate) => {
    if (newDate && newDate.toString() === 'Invalid Date') {
      this.setState({
        commentDate: null,
        dataModified: true,
      });
    } else {
      this.setState({
        commentDate: newDate,
        dataModified: true,
      });
    }
  };

  onEncounterTypeChange = (event) => {
    this.setState({
      encounterTypeId: event.target.value,
      dataModified: true,
    });
  };

  onTagSelectChange = (event, namespace) => {
    this.setState((state) => {
      let selected = event.target.value;
      if (!namespace.activity_notes_multiple) {
        selected = [selected];
      }
      return {
        tagSelect: {
          ...state.tagSelect,
          [namespace.id]: selected,
        },
        dataModified: true,
      };
    });
  };

  onFollowUpChange = (event) => {
    console.info(this.state.dueDate);
    //let dueDate = !this.state.dueDate ? new Date(Date.now() + DEFAULT_DUE_DAYS * 24 * 60 * 60 * 1000) : this.state.dueDate

    this.setState({
      needsFollowUp: event.target.checked,
      dataModified: true
    });
  };

  onDueDateChange = (newDate) => {
    this.setState({
      dueDate: newDate,
      dataModified: true,
    });
  };

  onAssignedUserChange = (event) => {
    this.setState({ assignedUserId: event.target.value, dataModified: true });
  };

  onCloseConfirmCancel = () => {
    this.setState({ confirmCloseOpen: false });
  };

  onSmartLocationSelected = (/* location */) => {
    // TODO: implement smart location selection
  };

  onSmartProviderSelected = (/* provider */) => {
    // TODO: implement smart provider selection
  };

  onSmartContactSelected = (/* contact */) => {
    // TODO: implement smart contact selection
  };

  linkDocument = (data) => {
    this.setState((state) => {
      let existing = false;
      state.documents.forEach((d) => {
        if (d.docId === data.docId) {
          existing = true;
        }
      });
      if (!existing) {
        state.documents.push(data);
//        this.startUploadNext(data);
      }
      return {
        documents: state.documents,
        dataModified: true,
        uploadDialogState: 'SUCCESS',
      };
    });
  }

  startUpload = (data) => {
    this.setState((state) => {
      let existing = false;
      state.documents.forEach((d) => {
        if (d.docId === data.docId) {
          existing = true;
        }
      });
      if (!existing) {
        state.documents.push(data);
        this.startUploadNext(data);
      }
      return {
        documents: state.documents,
        dataModified: true,
        uploadDialogState: 'SUCCESS',
      };
    });
  }

  startUploadNext = (data) => {
    if (this.state.editingDocument) {
      this.closeUploadDialog();
      this.props.dispatch(upsertDocument(data));
    } else {
      this.setState({
        uploadDialogState: 'LOADING',
      });

      const wakeupInterval = setInterval(
        () => {
          this.props.dispatch(wakeupServer());
        },
        5 * 60 * 1000, // ever 5 min make sure app doesn't logout
      );
      axiosInstance.post('/Documents', {
        name: data.name,
        description: data.description,
        client_id: data.client_id,
        original_filename: data.file.name,
        size_bytes: data.file.size,
        content_type: data.file.type
      }, {
        params: {
          selected_client_id: data.client_id,
        }
      }).then((response) => {
        const result = response.data;
        data.docId = response.data.docId;
        axios(result.uploadUrl, {
          method: 'PUT',
          onUploadProgress: (progressEvent) => {
            const percentCompleted = Math.round(
              (progressEvent.loaded * 1000) / progressEvent.total,
            ) / 10;
            this.setState({
              uploadProgress: percentCompleted,
            });
          },
          data: data.file,
          headers: {
            'content-type': data.file.type,
            // 'x-amz-acl': 'authenticated-read',
            // 'x-amz-meta-key': result.key,
          },
        }).then(() => {
          this.setState({
            uploadDialogState: 'SUCCESS',
          }, () => {
          });
          clearInterval(wakeupInterval);
        }).catch(() => {
          this.setState({
            uploadDialogState: 'ERROR',
          });
          clearInterval(wakeupInterval);
        });
      });
    }
  };


}

ProviderCommentsDialog.propTypes = {
  app: PropTypes.object,
  router: PropTypes.object,
  classes: PropTypes.object.isRequired,
  isMobile: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func,
  data: PropTypes.object,
  clientId: PropTypes.number.isRequired,
  tag: PropTypes.object,
  open: PropTypes.bool.isRequired,
  provider: PropTypes.object,
  contact: PropTypes.object,
  document: PropTypes.object,
  location: PropTypes.object,
  dispatch: PropTypes.func.isRequired,
  tagNamespaces: PropTypes.object,
  created: PropTypes.object,
  user: PropTypes.object,
  duplicate: PropTypes.boolean,
  clientUsers: PropTypes.array
};

function mapStateToProps(state) {
  const { contacts, user, app } = state;
  const usersStore = StoreUtil.get(state.users, StoreUtil.COMMON_LIST);
  const clientUsers = StoreUtil.isLoaded(usersStore) ? (usersStore.data || []) : [];

  return {
    app,
    user,
    created: StoreUtil.get(contacts, StoreUtil.COMMON_EDIT_ITEM),
    tagNamespaces: StoreUtil.get(
      state.tagNamespaces,
      API_TAG_NAMESPACES_LIST_BY_CLIENT,
    ),
    clientUsers,
  };
}
const c = withIsMobile(withStyles(styles)(ProviderCommentsDialog));
const connected = connect(mapStateToProps)(c);
const routed = withRouter(connected);
export { routed as ProviderCommentsDialog };
